/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { createFragmentContainer, graphql } from 'react-relay';

import { Button } from './ui/button';
import { X } from 'lucide-react';
import DeleteChannelUserMutation from '../mutations/DeleteChannelUserMutation';

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.onRemove = this.onRemove.bind(this);
    this.state = { foo: 'bar' };
  }

  onRemove(id) {
    return e => {
      return DeleteChannelUserMutation.commit(
        this.props.viewer.id,
        id,
        this.props.channel.id,
      );
    };
  }

  users() {
    return this.props.channel.users.edges.map(edge => {
      if (edge.node != null) {
        return (
          <div key={edge.node.id} className="flex flex-row items-center mb-2">
            <Button
              variant="ghost"
              size="icon"
              id={edge.node.id}
              onClick={this.onRemove(edge.node.id)}
            >
              <X className="h-4 w-4" />
            </Button>
            <div>{edge.node.fullName}&nbsp;&nbsp;</div>
            <div> {edge.node.email || ''} </div>
          </div>
        );
      }
      return null;
    });
  }

  render() {
    return <div>{this.users()}</div>;
  }
}

Users = createFragmentContainer(Users, {
  channel: graphql`
    fragment Users_channel on OwnedChannel {
      id
      users(first: 100) @connection(key: "Users_users") {
        edges {
          node {
            id
            fullName
            email
          }
        }
      }
    }
  `,
});

export default Users;
